import { splitBySpans, type Span } from "@/shared/utils/highlight";

/**
 * Texto com os termos da marca em destaque — o "negrito no termo
 * casado" (2026-09-21). Os trechos vêm do servidor sobre o mesmo texto
 * (`highlights` no payload da menção); aqui só se corta e se marca.
 * `<mark>` e não `<b>`: é destaque de busca, não ênfase de escrita, e
 * o leitor de tela anuncia a diferença.
 */
export function HighlightedText({
  text,
  spans,
}: {
  text: string;
  spans: Span[];
}) {
  if (!spans.length) return <>{text}</>;
  return (
    <>
      {splitBySpans(text, spans).map((segment, index) =>
        segment.marked ? (
          <mark key={index} className="term-mark">
            {segment.text}
          </mark>
        ) : (
          <span key={index}>{segment.text}</span>
        )
      )}
    </>
  );
}
